<template>
  <div class="tab">
    <main class="page_container">
      <TableLogs :data="data" :loading="loading" :link-keys="linkKeys" :keys="keys" @fetch="onFetchData" />
    </main>
  </div>
</template>
<script>
import TableLogs from "@/core/components/TableLogs/index";
import logsMixin from "@/core/components/TableLogs/logsMixin";
import { ApiService } from "@/api";

export default {
  name: "UsersLogs",
  components: {
    TableLogs,
  },
  mixins: [logsMixin],
  data() {
    return {
      keys: ["client_name", "email", "email_notification", "id", "refresh_password"],
      linkKeys: {
        id: `${process.env.BASE_URL}#/user/edit/`,
      },
    };
  },
  methods: {
    fetchLogs: ApiService.logs.getEmployeesLogs,
  },
};
</script>
